// extracted by mini-css-extract-plugin
module.exports = {"limitedBody":"_2UYVzhfMOcqmDnAnnWNVzs","heading":"VyaM4yTB2-zAvMXvc7eTw","searchBar":"_22kLtr1ECDNDVsDwLuvvkp","intro":"GDI7fnQSPfnQp-2Rc3Wx8","spinner":"DMx9PPs5CpJiS4M_XGvtW"};